import styled from '@emotion/styled';
import Errors from './Errors';
import theme from '../../theme';
import {ChangeEventHandler, FC} from 'react';
import WithLabel from "./WithLabel";

interface InputDivProps {
  theme?: typeof theme;
  disabled?: boolean;
  resize?: boolean;
  width?: string | number;
  height?: string | number;
  hasError?: boolean;
}

const StyledTextArea = styled.textarea<InputDivProps>(
  ({
    theme: { font, colors, space, fontSizes, fontWeights },
    disabled,
    resize,
    width = '100%',
    height = '96px',
    hasError,
  }) => ({
    width,
    height,
    minHeight: height,
    fontFamily: font,
    //fontWeight: fontWeights?.bold,
    fontSize: fontSizes?.m,
    color: colors?.primaryFont,
    padding: space?.s,
    border: `1px solid ${hasError ? colors?.alert : colors?.border}`,
    borderRadius: '4px',
    backgroundColor: disabled ? colors?.border : colors?.white,
    resize: resize ? `vertical` : `none`,

    '&:focus': {
      outline: 'none',
      borderColor: hasError ? colors?.alert : colors?.primary,
    },

    '&::placeholder': {
      color: colors?.secondaryFont,
      fontWeight: fontWeights?.thin,
    },
  })
);

export interface InputProps extends InputDivProps {
  showTextErrors?: boolean;
  errors?: string[] | boolean;
  autoFocus?: boolean;
  name?: string;
  placeholder?: string;
  readOnly?: boolean;
  value?: string | ReadonlyArray<string> | number;
  maxLength?: number;
  onChange?: ChangeEventHandler<HTMLTextAreaElement>;
  className?: string;
  label?: string;
}

const TextArea: FC<InputProps> = ({
  value,
  showTextErrors = true,
  errors,
  className,
  label,
  ...props
}) => {
  const input = (
    <div className={className}>
      <StyledTextArea {...props} value={value || ''} hasError={!!errors} />
      {showTextErrors ? <Errors {...{ errors }} /> : null}
    </div>
  );

  return label ? <WithLabel label={label}>{input}</WithLabel> : input;
}

export default TextArea;
